import "./App.css";
import Main from "./components/Main";

function App() {
  return (
    <div className="App" style={{
      minHeight: window.innerHeight
    }}>
      <Main />
    </div>
  );
}

export default App;
